import type { UseTranslationResponse } from 'react-i18next';
import { useTranslation } from 'react-i18next';

const namespace = 'features';
export const keyPrefix = 'move_departments';

export const useMoveDepartmentsTranslation = (): UseTranslationResponse<typeof namespace, typeof keyPrefix> => {
  return useTranslation(namespace, { keyPrefix });
};

export const ruRu = ({
  [keyPrefix]: {
    button: 'Перенести',
    title: 'Перенести подразделение',
    description: 'Перенос подразделения в рамках организационной структуры в другое головное подразделение',
    fields: {
      department: 'Куда перенести',
      department_placeholder: 'Выберите подразделение',
      department_empty: 'Подразделения не найдены',
    },
    submit: 'Перенести',
    cancel: 'Отмена',
    toast_success: 'Подразделение успешно перенесено',
    toast_error: 'Не удалось перенести подразделение',
  },
}) as Record<string, unknown>;

export const en = ({
  [keyPrefix]: {
    button: 'Move',
    title: 'Move department',
    description: 'Move a department within the organizational structure to another parent department',
    fields: {
      department: 'Move to',
      department_placeholder: 'Select department',
      department_empty: 'No departments found',
    },
    submit: 'Move',
    cancel: 'Cancel',
    toast_success: 'Department moved successfully',
    toast_error: 'Failed to move department',
  },
}) as Record<string, unknown>;

export const ptBr = ({
  [keyPrefix]: {
    button: 'Mover',
    title: 'Mover departamento',
    description: 'Mover um departamento dentro da estrutura organizacional para outro departamento pai',
    fields: {
      department: 'Mover para',
      department_placeholder: 'Selecione o departamento',
      department_empty: 'Nenhum departamento encontrado',
    },
    submit: 'Mover',
    cancel: 'Cancelar',
    toast_success: 'Departamento movido com sucesso',
    toast_error: 'Falha ao mover departamento',
  },
}) as Record<string, unknown>;

export const esEs = ({
  [keyPrefix]: {
    button: 'Mover',
    title: 'Mover departamento',
    description: 'Mover un departamento dentro de la estructura organizativa a otro departamento principal',
    fields: {
      department: 'Mover a',
      department_placeholder: 'Seleccionar departamento',
      department_empty: 'No se encontraron departamentos',
    },
    submit: 'Mover',
    cancel: 'Cancelar',
    toast_success: 'Departamento movido correctamente',
    toast_error: 'No se pudo mover el departamento',
  },
}) as Record<string, unknown>;
